export default "__VITE_ASSET__39552ba8__"